angular.module('cfn').directive('cfnInputTimeValue', [
  '$rootScope',
  '$log',
  '$timeout',
  'timeFormatter',
  function($rootScope, $log, $timeout, timeFormatter) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        mode: '&',
        model: '='
      },
      require: 'ngModel',
      template:
        '<input type="text" ng-model="model" class="part cfn-input-time-value">',
      link: function(scope, element, attrs, ngModelController) {
        let timeStrToInt; // function that is set later according to attribute mode ("hh" or "mm")
        let timeIntToStr; // function that is set later according to attribute mode ("hh" or "mm")
        let omitBlurEventOnce = false;

        init(attrs.mode);

        function init(mode) {
          switch (mode) {
            case 'hh':
              timeIntToStr = timeFormatter.hour.intToStr;
              timeStrToInt = timeFormatter.hour.strToInt;
              element.addClass('hh');
              break;

            case 'mm':
              timeIntToStr = timeFormatter.minute.intToStr;
              timeStrToInt = timeFormatter.minute.strToInt;
              element.addClass('mm');
              break;
            default:
              console.log('cfnInputTimeValue: wrong mode attribute value');
          }

          // add format transform handlers
          ngModelController.$formatters.push(mdl2inp);
          ngModelController.$parsers.push(inp2mdl);

          // add Eventhandlers
          element.bind('blur', onBlurCorrectModel);
        }

        function onBlurCorrectModel() {
          // e.g. if user only has put in an empty "", the model needs to be 0
          let modelVal = scope.model;
          let inputVal = element.val();
          let inputValInvalid = inputVal === '';
          let isInputNotComplete = inputVal.length === 1;

          if (omitBlurEventOnce) {
            return;
          } else {
            omitBlurEventOnce = false;
          }

          if (inputValInvalid) {
            updateInputfield(timeIntToStr(0));
          } else {
            updateInputfield(timeIntToStr(inputVal));
          }

          scope.$apply(function() {
            scope.model = timeIntToStr(inputVal);
          });
        }

        function inp2mdl(fromInputfield) {
          let newHourInt;

          newHourInt = timeStrToInt(fromInputfield);

          updateInputfieldIfNecessary(newHourInt, fromInputfield);

          return newHourInt;
        }

        function mdl2inp(num) {
          return timeIntToStr(num);
        }

        function updateInputfieldIfNecessary(newHourInt, fromInputStr) {
          if (fromInputStr.length >= 2) {
            // this omits the blur event and the according model apply-change that goes with it (jquery stuff)
            if (attrs.mode === 'hh') omitBlurEventOnce = true;

            // Trigger event so parent directive can select minute inputfield
            scope.$emit('userValueInputSeemsFinished', attrs.mode);
          }

          if (
            timeFormatter.directiveHelpers.checkIfInputfieldNeedsUpdate(
              newHourInt,
              fromInputStr
            )
          ) {
            updateInputfield(timeFormatter.hour.intToStr(newHourInt));
          }
        }

        function updateInputfield(newHourInt) {
          ngModelController.$setViewValue(newHourInt);
          ngModelController.$render();
        }
      }
    };
  }
]);
